import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Select from '../../../../../components/Select'

import { useSroiFilters } from '../../SroiFiltersContext'

import { getCategoricalLabels } from '../../SroiGraphs/RedesignedSroiGraphs/SocialValueByStakeholders/socialValueByStakeholdersHelpers'

import { socialReturnOnInvestmentReportSelector } from '../../../../../modules/selectors/socialReturnOnInvestment'

import useStyles from '../styles'

const StakeholderFilter = () => {
  const { selectedStakeholder, setSelectedStakeholder } = useSroiFilters()
  const classes = useStyles()
  const { t } = useTranslation()

  const report = useSelector(socialReturnOnInvestmentReportSelector)

  const formattedStakeholders = useMemo(() => {
    const categoricalImpact = report?.categorical_impact || []

    if (categoricalImpact.length) {
      const labels = getCategoricalLabels(categoricalImpact)

      return labels.map(label => {
        return {
          value: label,
          label: label
        }
      })
    } else {
      return []
    }
  }, [report])

  const onChangeHandler = useCallback(
    option => {
      setSelectedStakeholder(option.value)
    },
    [setSelectedStakeholder]
  )

  const clearInputHandler = useCallback(() => {
    setSelectedStakeholder(null)
  }, [setSelectedStakeholder])

  return (
    <Select
      className={classes.select}
      options={formattedStakeholders}
      isSearchable={false}
      value={selectedStakeholder}
      onChange={onChangeHandler}
      placeholder={t('All stakeholders')}
      showClearInputIcon={!!selectedStakeholder}
      onClearInput={clearInputHandler}
    />
  )
}

export default StakeholderFilter
